<template>
  <b-modal :active.sync="isActiveModal"
    has-modal-card
    trap-focus
    aria-role="dialog"
    aria-modal class="has-overflow">
      <div class="modal-card">
        <ValidationObserver ref="observer">
          <header class="modal-card-head">
              <p class="modal-card-title">Descargar Información Evaluaciones</p>
          </header>
          <section class="modal-card-body">
            <b-field expanded>
              <date-picker-range :from.sync="start" :to.sync="finish"/>
            </b-field>
            <b-field label="Solo Oficiales">
              <b-switch v-model="onlyOfficials">
                  {{ onlyOfficials ? 'Si' : 'No' }}
              </b-switch>
            </b-field>
            <h3 class="title is-6">
            Datos sin formato:
            </h3>
            <div class="buttons">
              <b-button type="is-info" @click="downloadRawExecutions" :loading="isLoadingRawExecutions" expanded>Resultados Generales</b-button>
            </div>
            <div class="buttons">
              <b-button type="is-info" @click="downloadRawExecutionsDetails" :loading="isLoadingRawExecutionsDetails" expanded>Resultados Detallados </b-button>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button type="is-default" @click="isActiveModal = false" expanded>Cerrar</b-button>
          </footer>
        </ValidationObserver>
      </div>
    </b-modal>
</template>

<script>
import ExportRawService from '@/services/ExportRawService'
import DatePickerRange from '@/components/controls/DatePickerRange'

export default {
  components: {
    DatePickerRange
  },
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false
    },
    startDate: {
      type: Date,
      default: null
    },
    endDate: {
      type: Date,
      default: null
    }
  },
  created () {
    this.start = this.$moment().startOf('month').toDate()
    this.finish = this.$moment().endOf('month').toDate()
  },
  data () {
    return {
      isActiveModal: false,
      isLoading: false,
      start: new Date(),
      finish: new Date(),
      onlyOfficials: true,
      isLoadingRawExecutions: false,
      isLoadingRawExecutionsDetails: false
    }
  },
  methods: {
    async getExecutionRaw () {
      let params = {
        'from': this.$moment(this.start).format('YYYY-MM-DD'),
        'to': this.$moment(this.finish).format('YYYY-MM-DD'),
        'official': this.onlyOfficials
      }
      let response = await ExportRawService.getRawExecutions(params)
      return response.data
    },
    async getRawExecutionsDetails () {
      let params = {
        'from': this.$moment(this.start).format('YYYY-MM-DD'),
        'to': this.$moment(this.finish).format('YYYY-MM-DD'),
        'official': this.onlyOfficials
      }
      let response = await ExportRawService.getRawExecutionsDetails(params)
      return response.data
    },
    async downloadRawExecutions () {
      this.isLoadingRawExecutions = true
      let data = await this.getExecutionRaw()
      this.isLoadingRawExecutions = false
      let fileName = `Resultados_evaluaciones_${this.dateFormated}.csv`
      this.generateFile(data, fileName)
      this.openAlert()
      this.isActiveModal = false
    },
    async downloadRawExecutionsDetails () {
      this.isLoadingRawExecutionsDetails = true
      let data = await this.getRawExecutionsDetails()
      this.isLoadingRawExecutionsDetails = false
      let fileName = `Resultados_evaluaciones_detallada_${this.dateFormated}.csv`
      this.generateFile(data, fileName)
      this.openAlert()
      this.isActiveModal = false
    },
    async generateFile (data, fileName) {
      var blob = new Blob(['\uFEFF' + data], { type: 'data:text/csv;charset=utf-8' })
      var fileURL = window.URL.createObjectURL(blob)
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', fileName)
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    }
  },
  computed: {
    dateFormated () {
      let startFormated = this.$moment(this.start).format('YYYY-MM-DD')
      let finishFormated = this.$moment(this.finish).format('YYYY-MM-DD')

      return `${startFormated}_${finishFormated}`
    }
  },
  watch: {
    startDate (value) {
      if (value) {
        this.start = value
      }
    },
    endDate (value) {
      if (value) {
        this.finish = value
      }
    },
    active () {
      if (this.active !== this.isActiveModal) {
        this.isActiveModal = this.active
      }
    },
    isActiveModal () {
      if (this.isActiveModal !== this.active) {
        this.$emit('update:active', this.isActiveModal)
      }
    }
  }
}
</script>
